import type { TileHeaderProps } from './TileHeader.types'
import { getTileHeaderCapitalLetter } from './TileHeader.utils'

function TileHeader(props: TileHeaderProps) {
  const { name } = props

  return (
    <div className="flex items-center gap-4">
      <div className="w-16 h-16 bg-gray-300 rounded flex items-center justify-center">
        <span className="text-2xl">{getTileHeaderCapitalLetter(name)}</span>
      </div>
      <div>
        <h1 className="text-2xl font-bold text-left">{name}</h1>
      </div>
    </div>
  )
}

export default TileHeader
